module.exports = __webpack_public_path__ + "img/kit.572fae3e.svg";